<template>
  <div id="header-img" class="box" style="text-align: center;">
    <!-- <div @click="seeToken"  :style="{right: tipsPos+'px'}" class="tips-box m-tips">
      <div class="m-tips"
           :style="{backgroundColor: color,borderRadius: '50%'}"
           style="width: 100%;height: 100%;cursor: pointer;">
        <i style="margin-right: 2px;" class="m-tips"></i>
        <i style="margin-right: 2px;" class="m-tips"></i>
        <i class="m-tips"></i>
      </div>
    </div> -->
    <!-- <div
      v-show="showTips"
      class="tips m-tips"
      :style="{boxShadow:'0 2px 6px rgba(0,0,0,.6)',right: tipsPos+'px'}">
      <div
        ref="tips"
        :style="{color: '#000000',backgroundColor: '#eeeeee'}">
        <p v-if="englishpc==1" style="border-bottom: 1px solid #aaaaaa;" @click="changeLanguage">{{ $t("message.tpl1.menu.language") }}</p>
        <p @click="login()" style="border-bottom: 1px solid #aaaaaa;">{{ $t("message.tpl1.menu.info") }}</p>
        <p v-if="showExit" @click="exit">{{ $t("message.tpl1.menu.exit") }}</p>
        <b class="m-tips"></b>
      </div>
    </div> -->
    <headerTop :baseInfo="baseInfo" :isregister='isregister'  :englishpc="englishpc*1"></headerTop>
    <div style="display: inline-block;height: 100%;margin: 0 auto;position: relative;">
      <!--<img ref="myimg" style="height: 100%;" v-lazy="url" :src="url" alt="">-->
      <i-header :slides="slides" :banner="url"></i-header>
    </div>
    <div v-if="false" :class="[flag1===0||flag1===null? 'bottom':'']" class="info-box">
      <div>
        <p style="width: 619px;font-size: 34px;font-weight: 700;word-spacing:25px;margin-bottom: 50px;">
          <!--神经外科重症监护新进展论坛暨第十三届神经外科学术会议-->
          {{baseInfo.cTitle}}
        </p>
        <p style="font-size: 18px;">
          <span style="vertical-align: middle;">{{baseInfo.cProvince}}</span>
          <i style="
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: #ffffff;">
          </i>
          <span style="vertical-align: middle;">{{baseInfo.cCity}}</span>
        </p>
        <p style="font-size: 18px;margin-top: 20px;font-weight: 500">
          <span>{{baseInfo.cStartDt}}</span>
          <span>-</span>
          <span>{{baseInfo.cEndDt}}</span>
        </p>
      </div>
    </div>
    <!-- <transition name="slide-fade">
      <div class="fixed" @click="login('')" v-if="fixed&&register"
           :style="{'background-color':myColor,fontSize: '14px',right: fixedPostRight+'px'}">
        个人报名
      </div>
    </transition> -->
    <transition name="slide-fade">
      <div v-show="fixed" ref="base-bm" class="base-bm" :style="{right: fixedPostRight+'px'}">
        <div class="child" v-if="register" @click="login('')">
          <img src="./imgs/reg.png" alt="">
          <!-- 个人报名 -->
          <p>{{ $t("message.tpl1.menu.register") }}</p>
        </div>
        <div  class="child" v-if="baseInfo.paperSubmitFl == 1" :class="{disable: baseInfo.paperSubmitFl == 0}" @click="reg1"
          >
          <img src="./imgs/onlinePaper.png" alt="">
          <!-- 在线投稿 -->
          <p>{{ $t("message.tpl1.menu.paperRegister") }}</p>
        </div>
        <div class="child" v-if="baseInfo.groupRegisterFl == 1" :class="{disable: baseInfo.groupRegisterFl == 0}" @click="teamReg">
          <img src="./imgs/teamreg.png" alt="">
          <!-- 团队报名 -->
          <p>{{ $t("message.tpl1.menu.teamReg") }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

  import loginPng from './login.png'
  import loginlogic from '@/commen/loginlogic'
  import headerTop from '@/components/headerTop/headerTop'

  //轮播图
  import iHeader from '../../tplCommon/header_pic/header_pic'
  let msg = {
    ch: {
      logOutSuccess: '退出成功!'
    },
    en: {
      logOutSuccess: 'successfully logged out'
    }
  }
  export default {
    components:{
      headerTop,iHeader
    },
    data() {
      return {
        register: false,
        loginPng: loginPng,
        fixedPostRight: 0,
        showTips: false,  // 显示我的报名信息，退出框
        tipsPos: 0,
        isLogin: false,
        language: 'ch',
        englishpc: 0,
        showExit: false, //如果登陆，就显示三个点，用来推出操作
      }
    },
    props: {
      url: {
        type: String,
      },
      navs2: {},
      showInfo: {
        type: Number
      },
      tmpRegisterFl: {
        type: Number
      },
      color: {
        type: String,
        default: () => {
          return '#f39800'
        },

      },
       isregister:{
          type:String
        },
      flag1: {
        type: Number,
        default: () => {
          return 0;
        }
      },
      baseInfo: {
        type: Object
      },
      fixed: {
        type: Boolean,
        default: () => {
          return true;
        }
      },
      slides: {
        type:Array
      }
    },
    methods: {
      changeLanguage(){
        let locale = localStorage.getItem('locale')
        let englishpc = localStorage.getItem('englishpc')

        locale = locale === 'ch' ? 'en' : locale === 'en' ? 'ch' : ''
        if(englishpc == 0){
          this.$Message.info('当前会议，暂时不支持英文网站')
          return
        }
        localStorage.setItem('locale', locale)
        setTimeout(() => {
          location.reload();
        }, 20);
      },
      setActive(e){
        let children = Array.prototype.slice.call(this.$refs['base-bm'].children,0);
        let that = this
        function outStyle (el) {
          el.style.backgroundColor = that.myColor
        }
        function inStyle (el) {
          el.style.backgroundColor = 'rgba(112,95,88,.9)'
        }
        children.forEach((item,i)=>{
          item.style.backgroundColor = this.myColor
        })
        children.forEach((item,i)=>{
          item.addEventListener('mouseover', ()=>{
            inStyle(item)
          })
          item.addEventListener('mouseout', ()=>{
            outStyle(item)
          })
        })
      },

      initFlag(navs){
        this.register = this.baseInfo.registerFl == 1
      },
      reg1(){
        if (this.baseInfo.paperSubmitFl == 0) return;
        if (this.checkLogin()) {
          let hostname = location.host;
          let cid = this.$route.params.cid;
            if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
          }
          let origin = window.location.origin;
          let path = `${origin}/submission/submit_cn/paperView/0?cid=${cid}&tpl=tpl1home`;
          // location.href = path;
          window.open(path)
        }

      },
      checkLogin(){
        let token = localStorage.getItem('token');
        let uid = localStorage.getItem('uid');
        if (!uid) {
//            跳转到登录页面
          if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
          }
          let origin = window.location.origin;
          // const origin = location.origin;
          const back = encodeURIComponent(location.href);
          debugger
          location.href = origin + `/login?back=${back}&cid=${this.$route.params.cid}`;
//          this.showBox = true;
          return false;
        }
        return true;
      },
      //      团队注册
      teamReg(){
        if (this.baseInfo.groupRegisterFl * 1 === 1) {
//              如果允许团队注册
          if (this.checkLogin()) {
//              如果登录成功
              if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
                window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
              }
              let origin = window.location.origin;
            const back = encodeURIComponent(location.href);
            let path = origin + `/teamreg/${this.$route.params.cid}?back=${back}`;
            window.open(path)
            return;
          }
        }
      },
      seeToken(){
        let token = localStorage.getItem('token');
        if (token === null) {
          this.showExit = false;
        } else {
          this.showExit = true;
        }
      },
      exit(){
        this.showTips = false;
        localStorage.removeItem('uid');
        localStorage.removeItem('token');
        this.$Message.info(msg[this.language].logOutSuccess);
      },
      computedR(){
        let docW = document.documentElement.clientWidth;
        console.log(docW);
        this.fixedPostRight = (docW - 1088) / 2 - 40;
        this.tipsPos = (window.document.documentElement.clientWidth - 1088) / 2;
      },
      login(path){
        loginlogic.bind(this)(path);
      },
      listenTips(e){
        let classname = e.target.className.toLowerCase();
        console.log(classname)
        if (classname.indexOf('m-tips') === -1) {
          this.showTips = false;
        } else {
          this.showTips = true;
        }
      },
      _getImgHeight(){
        setTimeout(() => {
//            let img = new Image();
//            img.addEventListener('load', () => {
//              let height = img.height;
//              console.log('获得高度了')
//              this.$emit('loaded')
//            }, false);
//            img.src = this.url+'?randomId = '+Math.random()*10;
        }, 20)
      }
    },
    computed: {
      myColor(){
        return this.color ? this.color : '#f39800'
      }
    },
    mounted() {
      this.initFlag(this.navs2);
      this.language = localStorage.getItem('locale');
      this.englishpc = localStorage.getItem('englishpc')
      setTimeout(() => {
        this.computedR();
        this.isLogin = localStorage.getItem('uid') ? true : false;
        window.addEventListener('resize', this.computedR);
        window.addEventListener('click', this.listenTips);
//      tips三个点点的按钮的位置
        this.tipsPos = (window.document.documentElement.clientWidth - 1088) / 2;
        this._getImgHeight();
        this.setActive()
      }, 20);
    },
    beforeDestroy(){
      window.removeEventListener(this.computedR)
      window.removeEventListener(this.listenTips)
    }
  }
</script>

<style lang="scss" scoped>
  .box {
    width: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    position: relative;
  }
  .info-box {
    display: inline-block;
    color: #ffffff;
    text-align: center;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
  }

  .bottom {
    top: auto;
    transform: translate(-50%, 0);
    bottom: 100px;
  }

  .bm-icon {
    vertical-align: middle;
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(./login.png) center center/contain;
    margin-right: 10px;
  }

  .base-bm {
    position: fixed;
    bottom: 76px;
    width: 78px;
    font-size: 0;
  }

  .base-bm > div {
    font-size: 14px;
    color: #ffffff;
    background-color: rgba(112,95,88,.9);
    margin-bottom: 1px;
    width: 100%;
    padding: 12px 0;
    cursor: pointer;
    &:first-child{
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    &:last-child{
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
    img{
      width: 34px;
      margin: 0;
    }
  }

  .fixed {
    width: 70px;
    line-height: 70px;
    background: red;
    text-align: center;
    bottom: 100px;
    position: fixed;
    right: 20px;
    border-radius: 50%;
    color: #ffffff;
    cursor: pointer;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateX(1000px);
    opacity: 0;
    border-radius: 0;
  }

  .tips-box {
    position: absolute;
    right: 5px;
    top: 5px;
    border-radius: 50%;
    color: #ffffff;
    width: 30px;
    height: 30px;
    font-size: 0;
    z-index: 20;
    background-color: red;
    text-align: center;
  }

  .tips-box i {
    border-radius: 50%;
    width: 4px;
    margin-top: 13px;
    height: 4px;
    line-height: 30px;
    display: inline-block;
    background-color: #ffffff;
  }

  .tips {
    width: 120px;
    color: #000000;
    background-color: #ffffff;
    top: 43px;
    position: absolute;
    margin-right: -45px;
    font-size: 16px;
    border-radius: 5px;
    z-index: 30;
  }

  .tips b {
    display: block;
    position: absolute;
    left: 50%;
    top: -16px;
    margin-left: -8px;
    border: 8px solid #eeeeee;
    border-left-color: transparent;
    border-top-color: transparent;
    border-right-color: transparent;
  }

  .tips p {
    cursor: pointer;
    padding: 5px 0;
    font-size: 14px;
  }

  .tips p:hover {
    background-color: #9f9f9f;
  }

  .disable {
    background-color: #cccccc !important;
    cursor: auto !important;
  }
</style>



// WEBPACK FOOTER //
// headerImg.vue?7fcf297c